import { SERVICES } from "@/lib/site";

export default function Services() {
    return (
        <section
            id="what"
            data-testid="services-section"
            className="py-24 md:py-32 lg:py-40 bg-bone2"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-5">
                        <span className="number-mark text-ink2">§ 03</span>
                        <h2
                            data-testid="services-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink"
                        >
                            What
                            <br />
                            <em className="italic font-light text-eucalyptus">
                                we do.
                            </em>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-7 md:pl-12 flex items-end">
                        <p className="text-ink2 text-lg md:text-xl leading-relaxed max-w-2xl">
                            Caring for Country works across the systems that
                            make Indigenous-led stewardship possible — from
                            cultural authority and governance, to delivery,
                            policy, investment and enterprise.
                        </p>
                    </div>
                </div>

                <div
                    data-testid="services-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-rule"
                >
                    {SERVICES.map((s) => (
                        <article
                            key={s.n}
                            data-testid={`service-${s.n}`}
                            className="border-r border-b border-rule p-8 md:p-10 bg-bone2 hover:bg-bone transition-colors group"
                        >
                            <div className="flex items-center justify-between mb-8">
                                <span className="number-mark text-ochre">
                                    — {s.n}
                                </span>
                                <span className="block w-6 h-px bg-ink2 group-hover:w-10 group-hover:bg-ochre transition-all duration-500" />
                            </div>
                            <h3 className="font-serif text-2xl md:text-[26px] leading-[1.15] text-ink mb-4">
                                {s.title}
                            </h3>
                            <p className="text-ink2 text-[15px] leading-relaxed">
                                {s.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
